import api, { API_URL } from "@/lib/api";

/**
 * Public CMS URL for an uploaded media item.
 * Prefer relative `/api/media/public/{id}` so www (nginx /api proxy) and api host both work.
 * Absolute API_URL links lock content to one origin and break after cutovers.
 */
export function mediaPublicUrl(itemOrId) {
  if (!itemOrId) return "";
  if (typeof itemOrId === "object") {
    if (itemOrId.external_url) return itemOrId.external_url;
    if (itemOrId.url && String(itemOrId.url).startsWith("http") && !String(itemOrId.url).includes("/api/media/public/")) {
      return itemOrId.url;
    }
    if (itemOrId.id) return `/api/media/public/${itemOrId.id}`;
    return "";
  }
  return `/api/media/public/${itemOrId}`;
}

/** Absolute URL for admin UI previews (admin host has no /api proxy). */
export function mediaAbsolutePublicUrl(itemOrId) {
  const rel = mediaPublicUrl(itemOrId);
  if (!rel) return "";
  if (/^https?:\/\//i.test(rel)) return rel;
  return `${API_URL}${rel}`;
}

/** Preview through the public media URL. The file endpoint no longer accepts a token in the query string. */
export function mediaPreviewUrl(item) {
  if (!item) return "";
  if (item.external_url) return item.external_url;
  return mediaAbsolutePublicUrl(item);
}

export async function fetchMediaObjectUrl(item) {
  if (!item?.id) return item?.external_url || "";
  if (item.external_url) return { src: item.external_url, revoke: false };
  try {
    const { data } = await api.get(`/media/file/${item.id}`, { responseType: "blob" });
    return { src: URL.createObjectURL(data), revoke: true };
  } catch {
    if (item.external_url) return { src: item.external_url, revoke: false };
    throw new Error("Media file unavailable");
  }
}
